import dedent from 'ts-dedent';
import { ColumnDataType, Provider, WorkflowComponentParamType } from '../types';
import { addColumn, removeColumn } from '../utils/schemas';
import { SelectWorkflowComponent } from './common/selectcomponent';
import { SINGLE_OUTPUT_NAME } from './common/singleoutputcomponent';
class Unnest extends SelectWorkflowComponent {
    constructor() {
        super({
            name: 'native.unnest',
            group: 'Aggregation',
            title: 'Unnest',
            description: `
        This component unnests the arrays contained in a column.
    `,
            starred: true
        }, [
            {
                name: 'source',
                type: WorkflowComponentParamType.InputTable,
                title: 'Source table'
            },
            {
                name: 'col',
                type: WorkflowComponentParamType.Column,
                title: 'Column',
                parent: 'source'
            },
            {
                name: 'arraytype',
                type: WorkflowComponentParamType.Selection,
                title: 'Array inner type',
                options: Object.values(ColumnDataType)
            }
        ]);
        this.supportedProviders = [Provider.BigQuery, Provider.DatabricksRest];
    }
    getInnerSql({ params, connection }) {
        switch (connection.type) {
            case Provider.BigQuery:
                return `
    SELECT * EXCEPT (${params.col})
    FROM ${connection.quoteName(params.source)}, UNNEST (${params.col}) ${params.col}_unnested`;
            case Provider.DatabricksRest:
                return dedent `
    SELECT /*+ REPARTITION(40) */
      * EXCEPT (${params.col}), EXPLODE (${params.col}) AS ${params.col}_unnested
    FROM ${connection.quoteName(params.source)}`;
            default:
                return null;
        }
    }
    canProvideOutputSchemas() {
        return true;
    }
    _getOutputSchemas({ workflow, params, schemas, connection, componentName }) {
        const tablename = params.source;
        const columns = this._getSchemaForTablename(tablename, schemas, connection);
        if (columns == undefined) {
            return [];
        }
        const fqn = this._getDryRunOutputTableFqn(workflow, params, connection, componentName, SINGLE_OUTPUT_NAME);
        const arraytype = connection.dataProviderTypeToColumnType(params.arraytype);
        let schema = addColumn(columns, {
            name: `${params.col}_unnested`,
            type: arraytype
        });
        schema = removeColumn(schema, params.col);
        return [
            {
                fqn,
                schema
            }
        ];
    }
    getVersion(provider) {
        return '2';
    }
}
export { Unnest };
